import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import { GetOrdersPageResponse } from './types';

export const getOrdersPage = async (): Promise<AxiosResponse<GetOrdersPageResponse>> => {
    const response = await api.get('/commerce/checkout/orderspagecontent');

    return response;
};
